import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';
import type { GameTicketMPNotification } from '@swf/core/types/Notification';

import defaultHeaderImg from '../../assets/images/default-header.png';
import GameTicketBack from '../../components/CardBack/Default';
import GameTicketFront from '../../components/GameTicket/GameTicket';
import { ActionType, FormatType } from '../../enums';

import {
  TXTCLI_More_information,
  TXTCLI_Play,
  TXTMOB_ExpiresX,
  TXTWCL_CongratulationsX_you_have_been_ELL,
  TXTWCL_Play_later,
  TXTWCL_Plays_availableX
} from './MiniGameTicket.messages.json';

export default {
  front: {
    view: GameTicketFront,
    viewConfig: {
      title: {
        tag: TXTWCL_CongratulationsX_you_have_been_ELL,
        values: { 0: 'gameTicketName' }
      },
      moreInfoLabel: { tag: TXTCLI_More_information },
      defaultHeaderImageURL: defaultHeaderImg,
      showCloseIcon: true,
      displayAttributes: [
        {
          attrKey: 'playsAvailable',
          attrLabel: { tag: TXTWCL_Plays_availableX },
          attrFormatterType: FormatType.Number
        },
        {
          attrKey: 'expiration',
          attrLabel: { tag: TXTMOB_ExpiresX },
          attrFormatterType: FormatType.Date
        }
      ],
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_Play },
          actionFunction: ({ attributes, notificationId }: ActionParams) => {
            const { minigameType, ticketTypeId } =
              attributes as GameTicketMPNotification['attributes'];
            dispatch.modal.enqueue({
              path: `/account/bonus-game/${minigameType}`,
              locationState: {
                gameTicketTypeId: ticketTypeId,
                ...attributes
              }
            });
            dispatch.notification.delete({ notificationId });
            dispatch.modal.close('/mpnotifications');
          }
        },
        {
          actionType: ActionType.Secondary,
          actionLabel: { tag: TXTWCL_Play_later },
          actionFunction: ({ notificationId }: ActionParams) => {
            dispatch.notification.delete({ notificationId });
            dispatch.modal.close('/mpnotifications');
          }
        }
      ]
    }
  },
  back: {
    view: GameTicketBack,
    viewConfig: {
      title: { tag: TXTCLI_More_information }
    }
  }
};
